import { Box, Stack, TextField, Button, Tooltip, Typography, Autocomplete, FormControlLabel, Checkbox, createFilterOptions } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Colors } from '../../../Styles/Colors'
import { DataGrid } from '@mui/x-data-grid'
import { CommonEditButton, CommonGridToolBarWithFilterText, DeletePopup } from '../../../Components/Common Components/CommonComponents'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import { gstPercentage } from '../../../Utility/Constants'

const drugList = {
    drugCode: '',
    brandName: '',
    genericName: null,
    dosageType: null,
    strength: '',
    hsnCode: '',
    manufactureName: null,
    GSTPercent: null,
    recommendedBy: null,
    Group: '',
    Schedule: '',
    isEdit: false
}
export default function ExternalDrugMaster(props) {
    const [DrugData, setDrugData] = useState([]);
    const [DoseType, setDoseType] = useState([]);
    const [ManufactureList, setManufactureList] = useState([]);
    const [RecommendedList, setRecommendedList] = useState([]);
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    const [drugStates, setdrugStates] = useState(drugList);
    const [message, setMessage] = useState({
        isErrorMsgText: '',
        successMsgText: '',
        isErrorMsg: false,
        successMsg: false,
    })
    const [isActive, setisActive] = useState(true);
    const [EditID, setEditID] = useState(null);
    const [isDelete, setisDelete] = useState(false);
    const [deletedID, setdeletedID] = useState(null);
    const [delIDs, setdelIDs] = useState([]);
    const [isloader, setisloader] = useState(false);
    const [CheckBoxList, setCheckBoxList] = useState([]);
    const [EditPopup, setEditPopup] = useState(false);
    const [genericList, setgenericList] = useState([]);
    const [hsnError, setHsnError] = useState('');

    let commonDisable = props?.Access?.editAccess

    useEffect(() => {
        fetchData(Serviceurls.GET_EXTERNAL_DRUG_DATA, setDrugData);
        fetchData(Serviceurls.PHARMA_DOSAGE_TYPE_LIST + `?global_master=true`, setDoseType);
        fetchData(Serviceurls.PURCHASE_MANUFACTURER_GET + `?manufacturer_name=${""}`, setManufactureList);
        fetchData(Serviceurls.FO_CONFIG_OPDOCTORNAME, setRecommendedList);
        getGenericName()
    }, []);

    const errorMessage = (message) => {
        setMessage({
            ...message,
            isErrorMsg: true,
            isErrorMsgText: message,
            transmit: false,
            saveLoad: false
        })
    }

    const successMessage = (message) => {
        setMessage({
            ...message,
            successMsg: true,
            successMsgText: message,
        })
    }

    const msgClose = () => {
        setMessage({
            ...message,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    const fetchData = async (url, setter) => {
        try {
            setisloader(true);
            const response = await RestAPIService.getAll(url);
            if (response.data.status === "success") {
                let result = response?.data?.data || [];
                setter(result);
            }
        } catch (e) {
            if (e?.response?.data?.status === "fail") {
                errorMessage(e.response.data.message);
            } else {
                errorMessage(e.message);
            }
        } finally {
            setisloader(false);
        }
    };

    const getGenericName = async () => {
        try {
            setisloader(true);
            const response = await RestAPIService.getAll(Serviceurls.FO_DRUG_MASTER);
            if (response.data.status === "success") {
                let result = response?.data?.generic_names || [];
                setgenericList(result);
            }
        } catch (e) {
            if (e?.response?.data?.status === "fail") {
                errorMessage(e.response.data.message);
            } else {
                errorMessage(e.message);
            }
        } finally {
            setisloader(false);
        }
    };

    const postDrugData = () => {
        try {
            if (hsnError && isActive) {
                return errorMessage(hsnError || 'Please correct HSN Code.')
            }
            if (!drugStates.brandName || !drugStates.genericName || !drugStates.strength || !drugStates.dosageType) {
                return errorMessage('Please Enter All Mandatory Fields.')
            }
            let data = {
                "drug_name": drugStates.brandName || "",
                "generic_name": drugStates.genericName || '',
                "dosagetype_id": drugStates.dosageType || null,
                "drug_strength": drugStates.strength || '',
                "hsn_code": drugStates.hsnCode || '',
                "manufacturer_name": drugStates.manufactureName?.manufact_id || drugStates.manufactureName || '',
                "gst_percentage": drugStates.GSTPercent?.value || null,
                "recommended_by": drugStates.recommendedBy?.doctor_id || drugStates.recommendedBy || '',
                "group": drugStates.Group || '',
                "schedule": drugStates.Schedule || '',
                "is_active": isActive,
            }
            if (EditID) {
                data['id'] = EditID
            }
            setisloader(true)
            RestAPIService.create(data, Serviceurls.GET_EXTERNAL_DRUG_DATA)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        fetchData(Serviceurls.GET_EXTERNAL_DRUG_DATA, setDrugData);
                        ClearFunc()
                        setisloader(false)
                        setEditPopup(false)
                        setdrugStates(prev => ({ ...prev, isEdit: false }))
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const deleteDrug = () => {
        try {
            RestAPIService.delete(Serviceurls.GET_EXTERNAL_DRUG_DATA + `?id=${deletedID ? [deletedID] : (delIDs || [])}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        fetchData(Serviceurls.GET_EXTERNAL_DRUG_DATA, setDrugData);
                        setCheckBoxList([]);
                        ClearFunc()
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const hsnErrorFromValue = (value) => {
        if (!value) return '';
        if (value.length > 8) return 'HSN Code exceeds the maximum allowed character limit';
        if (!/^\d*$/.test(value)) return 'HSN Code must contain only 8 numeric characters';
        return '';
    };

    const onHsnCodeChange = (e) => {
        const input = e.target;
        const value = input.value;
        const prevValue = drugStates.hsnCode || '';
        const cursorPos = input.selectionStart;

        if (value.length < prevValue.length) {
            setdrugStates((prev) => ({ ...prev, hsnCode: value }));
            const err =
                value && (!/^\d*$/.test(value) || value.length > 8)
                    ? 'HSN Code must contain only up to 8 numeric characters'
                    : '';
            setHsnError(err);
            setTimeout(() => input.setSelectionRange(cursorPos, cursorPos), 0);
            return;
        }

        if (/^\d*$/.test(value) && value.length <= 8) {
            setdrugStates((prev) => ({ ...prev, hsnCode: value }));
            setHsnError('');
            setTimeout(() => input.setSelectionRange(cursorPos, cursorPos), 0);
        } else {
            // Input rejected (extra digit, non-digit, etc.); value in state unchanged.
            // If the stored value is already valid, do not show an error—input was silently capped.
            const errFromPrev = hsnErrorFromValue(prevValue);
            setHsnError(errFromPrev || '');
        }
    };

    const onChangeHandler = (e, name) => {
        let value = e.target.value
        switch (name) {
            case 'brandName':
                if (value === "" || value.length <= 50) {
                    setdrugStates({ ...drugStates, [name]: value.trimStart() });
                }
                break
            case 'strength':
                if (value === "" || value.length <= 10) {
                    setdrugStates({ ...drugStates, [name]: value.trimStart() });
                }
                break
            default:
                if (value === "" || value.length <= 150) {
                    setdrugStates({ ...drugStates, [name]: value.trimStart() });
                }
                break;
        }
    }

    const onChangeAuto = (e, val, name) => {
        switch (name) {
            case 'drugType':
                setdrugStates({ ...drugStates, [name]: val });
                break
            default:
                setdrugStates({ ...drugStates, [name]: val })
                break
        }
    }

    const textBox = (label, name, val, list, width) => {
        return (
            <Box>
                {name === 'dosageType' ?
                    <Autocomplete
                        size={'small'}
                        options={list}
                        name={name}
                        getOptionLabel={(option) => option}
                        value={val}
                        sx={{ width: width, marginRight: '1vw' }}
                        onChange={(event, newValue) => { onChangeAuto(event, newValue, name) }}
                        renderInput={(params) => <TextField {...params} label={label} />}
                    />
                    :
                    <TextField
                        size='small'
                        name={name}
                        id="drug-master"
                        disabled={name === 'drugCode'}
                        value={val}
                        sx={{ width: width, marginRight: '1vw' }}
                        label={label}
                        onChange={(e) => {
                            if (name === 'hsnCode') {
                                onHsnCodeChange(e);
                            } else {
                                onChangeHandler(e, name);
                            }
                        }}
                        helperText={name === 'hsnCode' ? hsnError : undefined}
                        error={name === 'hsnCode' && !!hsnError}
                        autoComplete="off"
                        variant="outlined"
                    />
                }
            </Box>
        )
    }

    const grpDelete = () => {
        setisDelete(true)
    }

    const tableView = () => {

        const gridToolBar = () => {
            return (
                <Box>
                    <CommonGridToolBarWithFilterText isDelete={delIDs?.length > 0} removeData={grpDelete.bind(this)} />
                </Box>

            )
        }

        const handleTableCheckbox = (id) => {
            let selectedIDs = new Set(id);
            setCheckBoxList(id)
            let selectedRows = DrugData.filter((row) => selectedIDs.has(row.sno));
            let FinalData = []
            selectedRows.forEach((item) => {
                FinalData.push(item.id)
            })
            setdelIDs(FinalData)
        }

        DrugData?.forEach((element, index) => element.sno = index + 1)
        const columns = [
            {
                field: 'drug_code', headerName: 'External Drug Code', flex: 0.16,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.drug_code ? params?.row?.drug_code : '-'}</Box>)

            },
            {
                field: 'drug_name', headerName: 'Brand Name', flex: 0.19,
                renderCell: (params) => (params.row.drug_name ? params.row.drug_name?.length > 25 ?
                    <Tooltip placement="top" title={params.row.drug_name}><Typography fontSize={'1vw'}>{params.row.drug_name?.slice(0, 25) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'1vw'}>{params.row.drug_name}</Typography> : '-')

            },
            {
                field: 'generic_name', headerName: 'Generic Name', flex: 0.19,
                renderCell: (params) => (params.row.generic_name ? params.row.generic_name?.length > 25 ?
                    <Tooltip placement="top" title={params.row.generic_name}><Typography fontSize={'1vw'}>{params.row.generic_name?.slice(0, 25) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'1vw'}>{params.row.generic_name}</Typography> : '-')

            },
            {
                field: 'dosage_type', headerName: 'Dosage Type', flex: 0.18,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.dosage_type ? params?.row?.dosage_type : '-'}</Box>)

            },
            {
                field: 'drug_strength', headerName: 'Dosage Strength', flex: 0.18,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.drug_strength ? params?.row?.drug_strength : '-'}</Box>)

            },
            ...(commonDisable ? [{
                field: 'action', headerName: 'Action', flex: 0.10, headerAlign: 'center', align: 'center',
                renderCell: (params) => (
                    <Stack direction="row" alignItems="center" spacing={4}>
                        <Stack direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
                            <CommonEditButton size="1.5vw" disable={drugStates.isEdit} onClick={() => {
                                const hsn = params.row.hsn_code ? params.row.hsn_code : '';
                                setHsnError(hsnErrorFromValue(hsn));
                                setdrugStates({
                                    ...drugStates,
                                    drugCode: params.row.drug_code,
                                    brandName: params.row.drug_name,
                                    genericName: params.row.generic_name,
                                    dosageType: params.row.dosage_type,
                                    strength: params.row.drug_strength,
                                    hsnCode: hsn,
                                    manufactureName: params.row.manufacturer_name,
                                    GSTPercent: gstPercentage.find((item) => +item?.value === params.row.gst_percentage) || null,
                                    recommendedBy: params.row.recommended_by,
                                    Group: params.row.group,
                                    Schedule: params.row.schedule,
                                    isEdit: true
                                })
                                setEditID(params.row.id)
                                setisActive(params.row.is_active)
                            }} />
                        </Stack>
                    </Stack>)
            }] : [])
        ]
        return (
            <Box sx={{ height: '54vh' }}>
                <DataGrid
                    checkboxSelection={commonDisable ? true : false}
                    selectionModel={CheckBoxList}
                    onSelectionModelChange={(id) => handleTableCheckbox(id)}
                    isRowSelectable={() => !drugStates.isEdit}
                    rows={DrugData}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    page={page}
                    pageSize={pageSize}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    onPageChange={(newPage) => { setpage(newPage) }}
                    onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
                    rowsPerPageOptions={[10, 20, 30]}
                    pagination
                    headerHeight={40}
                    getRowClassName={(params) => params.row.is_active === false ? 'gray-row' : ''}
                    sx={{
                        "& .gray-row .MuiDataGrid-cell": {
                            backgroundColor: "#e8e7e7 !important",
                            color: "black !important",
                        },
                        "& .gray-row .MuiDataGrid-cell[data-field='action'], & .gray-row:has(.MuiDataGrid-cell--checkbox)": {
                            backgroundColor: "white !important",
                            color: "black !important",
                        },
                        "& .gray-row .MuiDataGrid-cell:nth-child(1)": {
                            backgroundColor: "white !important",
                        }
                    }}
                    density='compact'
                    disableSelectionOnClick
                    loading={isloader}
                />
            </Box>
        )
    }

    const ClearFunc = () => {
        setdrugStates(drugList)
        setHsnError('');
        setisActive(true);
        setEditID(null);
        setisDelete(false);
        setdelIDs([]);
    }

    const PopupClose = () => {
        setisDelete(false);
        setdeletedID(null);
        setEditPopup(false);
    }
    const filter = createFilterOptions();
    return (
        <Box component={'div'} sx={{ minHeight: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw', boxSizing: 'border-box' }}>
            <Box component={'div'} sx={{ minHeight: '22.5vh', width: '93vw', backgroundColor: 'white', padding: '.6vw', boxSizing: 'border-box', marginBottom: '0.75vw' }}>
                <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', rowGap: '0.5vw' }}>
                    {textBox("External Drug Code", 'drugCode', drugStates?.drugCode, '', '14.5vw')}
                    {textBox("Brand Name *", 'brandName', drugStates.brandName, '', '14.5vw')}
                    <Autocomplete
                        size="small"
                        freeSolo
                        sx={{ width: "14.5vw", marginRight: "1vw" }}
                        options={genericList || []}
                        getOptionLabel={(option) => (typeof option === "string" ? option : option)}
                        value={drugStates?.genericName || ""}
                        filterOptions={(options, params) => {
                            const filtered = filter(options, params);
                            return filtered.slice(0, 100);
                        }}
                        onChange={(event, newValue) => {
                            setdrugStates({
                                ...drugStates,
                                genericName: newValue || "",
                            });
                        }}
                        onInputChange={(event, newInputValue) => {
                            setdrugStates({
                                ...drugStates,
                                genericName: newInputValue,
                            });
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Generic Name *"
                                InputProps={{
                                    ...params.InputProps,
                                    emed_tid: "generic_name",
                                }}
                            />
                        )}
                    />
                    {textBox("Dosage Type *", 'dosageType', drugStates.dosageType, DoseType, '14.5vw')}
                    {textBox("Dosage Strength *", 'strength', drugStates.strength, '', '14.5vw')}
                    {textBox("HSN Code", 'hsnCode', drugStates.hsnCode, '', '14.5vw')}
                </Box>
                <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start',  rowGap: '0.5vw', marginTop: '1vw' }}>
                    <Autocomplete
                        freeSolo
                        disableClearable
                        value={drugStates.manufactureName || ""}
                        sx={{ width: "14.5vw", marginRight: '1vw' }}
                        size="small"
                        options={ManufactureList || []}
                        getOptionLabel={option => typeof (option) === "string" ? option : option.manufacturer_name || ""}
                        onChange={(event, newRoute) => {
                            let states = { ...drugStates }
                            if (newRoute) {
                                states['manufactureName'] = newRoute.manufacturer_name || newRoute;
                            } else {
                                states['manufactureName'] = '';
                            }
                        }}
                        onInputChange={(e, value) => {
                            if (value.length <= 100) {
                                setdrugStates({ ...drugStates, manufactureName: value });
                            }
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={"Manufacture Name"}
                                autoComplete="off"
                                size="small"
                                inputProps={{
                                    ...params.inputProps,
                                    maxLength: 100
                                }}
                                InputProps={{
                                    ...params.InputProps,

                                }}
                            />
                        )}
                    />
                    <Autocomplete
                        size='small'
                        sx={{ width: '14.5vw', marginRight: '1vw' }}
                        options={gstPercentage || []}
                        getOptionLabel={(option) => (typeof (option) === "string" ? option : option?.label)}
                        value={drugStates?.GSTPercent}
                        onChange={(event, newValue) => {
                            if (newValue) {
                                setdrugStates({ ...drugStates, GSTPercent: newValue })
                            } else {
                                setdrugStates({ ...drugStates, GSTPercent: null })
                            }
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={"Select GST (%)"}
                                InputProps={{
                                    ...params.InputProps,
                                    emed_tid: "gstReport_filter_selectServiceType"
                                }}
                            />
                        )}
                    />
                    <Autocomplete
                        freeSolo
                        disableClearable
                        value={drugStates.recommendedBy || ""}
                        sx={{ width: "14.5vw", marginRight: '1vw' }}
                        size="small"
                        options={RecommendedList || []}
                        getOptionLabel={option => typeof (option) === "string" ? option : option.doctor_name || ""}
                        onChange={(event, newRoute) => {
                            let states = { ...drugStates }
                            if (newRoute) {
                                states['recommendedBy'] = newRoute.doctor_name || newRoute;
                            } else {
                                states['recommendedBy'] = '';
                            }
                        }}
                        onInputChange={(e, value) => {
                            if (value.length <= 100) {
                                setdrugStates({ ...drugStates, recommendedBy: value })
                            }
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={"Recommended By"}
                                autoComplete="off"
                                size="small"
                                inputProps={{
                                    ...params.inputProps,
                                    maxLength: 100
                                }}
                                InputProps={{
                                    ...params.InputProps,
                                }}
                            />
                        )}
                    />
                    {textBox("Group", 'Group', drugStates.Group, '', '14.5vw')}
                    {textBox("Schedule", 'Schedule', drugStates.Schedule, '', '14.5vw')}
                </Box>
                <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginTop: "1vw", flexWrap: 'wrap', rowGap: '0.75vw', paddingTop: '0.25vw' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <FormControlLabel control={<Checkbox checked={isActive} onChange={(e) => { setisActive(e.target.checked) }} disabled={!EditID} size='small' />} label={"Active"} />
                    </Box>
                    <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', flexShrink: 0, gap: '1vw' }}>
                        <Button size='small' disabled={!commonDisable} variant='outlined' sx={{ textTransform: 'capitalize', minWidth: '7vw' }} onClick={() => { ClearFunc() }}>Clear</Button>
                        <Button size='small' disabled={!commonDisable || (!!hsnError && !(EditID && !isActive))} variant='contained' sx={{ textTransform: 'capitalize', minWidth: '7vw' }} onClick={() => { EditID && !isActive ? setEditPopup(true) : postDrugData() }}>{drugStates?.isEdit ? 'Update' : 'Save'}</Button>
                    </Box>
                </Box>
            </Box>
            <Box component={'div'} sx={{ height: '54vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white' }}>
                {tableView()}
            </Box>
            {
                message.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={message.isErrorMsgText}
                        msgPop={msgClose}
                    />
                    : null
            }
            {
                message.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={message.successMsgText}
                        msgPop={msgClose}
                    />
                    : null
            }
            {EditPopup ?
                <DeletePopup
                    DeletTitle={`This action will affect in External Drug mapping as well, Are you sure you want to In-Active this item ?`}
                    deleteAlertPopupClose={PopupClose.bind(this)}
                    removeData={postDrugData.bind(this)}
                    ButtonText={'Yes'}
                />
                : null}
            {
                isDelete ?
                    <DeletePopup
                        DeletTitle={`Are you sure, Do you want to delete this External Drug ?`}
                        DeleteNotify={"If you remove this, this could be effect in entire Configuration"}
                        deleteAlertPopupClose={PopupClose.bind(this)}
                        removeData={deleteDrug.bind(this)}
                    />
                    : null
            }
        </Box >
    )
}
